module.exports = __webpack_public_path__ + "img/yg02-04.55cd2341.png";